import React  from 'react'
import DropDown from '../dropdown';
import {Guests} from '../../../api/services/next'
import PropTypes from "prop-types";

const ApartmentOwnersDropDown = ({spec, ...rest}) => {
    return <DropDown 
    api={Guests.GetApartmentOwners} 
    spec={spec}
    textField={(item) => `${item.FirstName} ${item.LastName}`}
    valueField="Id"
    {...rest}/>
}

ApartmentOwnersDropDown.propTypes = {
    spec: PropTypes.object,
  }
export default ApartmentOwnersDropDown
